import axios from 'axios';
import { URL_GET_LANGUAGE_TYPES } from 'constants/urls';

/**
 * @function getLanguageTypes
 * @async
 * @returns { Promise<Array> } data
 */
async function getLanguageTypes() {
	const { data } = await axios({
		method: 'GET',
		url: URL_GET_LANGUAGE_TYPES,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
		},
		options: 'cantrackv3',
	});
	return data;
}

export default getLanguageTypes;
